<template>
  <div class="collect-content" @click.stop="handleCollect(menuItem)">
    <i :key="menuItem.menuId" :class="['icon', isCollect ? 'icon-collect' : 'icon-uncollect']"></i>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  menuItem: {
    type: Object,
    default: () => ({})
  }
})

const store = useStore()

const isCollect = computed(() => {
  const { menuId } = props.menuItem
  return store.state.menu.collectList.some(item => item.menuId === menuId)
})

const handleCollect = async menuItem => {
  try {
    const { menuId, menuName, menuRouteUrl } = menuItem
    const item = { menuId, menuName, menuRouteUrl }

    if (isCollect.value) {
      // 取消收藏
      store.commit('menu/removeCollect', item)
    } else {
      // 收藏
      store.commit('menu/addCollect', item)
    }
  } catch (error) {
    console.log(error)
  }
}
</script>

<style lang="scss" scoped>
.collect-content {
  width: 40px;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .icon-collect {
    background-image: url('~@/assets/define-icon/icon-collect.svg');
  }
  .icon-uncollect {
    background-image: url('~@/assets/define-icon/icon-uncollect.svg');
  }
}
</style>
